import { useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { GEOMETRY_OUTLINE, GEOMETRY_LABELS, trafficLightGlyph } from './mapIcons';

/**
 * SEMAFIX v3: the flow/capacity scale sits at the bottom-left of the map.
 * The intersection legend (bottom-right) no longer repeats it.
 */
const NODE_TYPES = [
  { key: 'T', label: 'T' },
  { key: 'rotatoria', label: 'Rotatoria' },
  { key: 'cross', label: 'Incrocio' },
  { key: 'altro', label: 'Altro' },
];

function ConventionLight({ colored, status, label }) {
  return (
    <div className="semafix-legend-conv-item">
      <span
        className={`semafix-legend-conv-light${status ? ` ${status}` : ''}`}
        dangerouslySetInnerHTML={{ __html: trafficLightGlyph(colored) }}
      />
      <span>{label}</span>
    </div>
  );
}

export function SemafixFlowLegend({ flowsVisible, onToggleFlows }) {
  return (
    <button
      type="button"
      className={`semafix-flow-legend${flowsVisible ? '' : ' is-off'}`}
      onClick={() => onToggleFlows(!flowsVisible)}
      aria-pressed={flowsVisible}
    >
      <span className="semafix-flow-legend-title">
        <span className="semafix-legend-vc-swatch" />
        <span>Flusso / capacità (V/C)</span>
      </span>
      {flowsVisible && (
        <div className="semafix-legend-gradient">
          <div className="legend-gradient-bar semafix-gradient-vc" />
          <div className="legend-labels">
            <span className="legend-label">Basso</span>
            <span className="legend-label">Critico</span>
          </div>
        </div>
      )}
    </button>
  );
}

export default function SemafixLegend({
  nodeTypeFilters,
  onToggleNodeType,
  nodeTypeCounts = {},
}) {
  const [open, setOpen] = useState(() => (
    typeof window === 'undefined' || !window.matchMedia
      ? true
      : window.matchMedia('(min-width: 901px)').matches
  ));

  return (
    <div className={`semafix-legend-panel ${open ? 'is-open' : 'is-collapsed'}`}>
      <button className="semafix-legend-panel-head" type="button" onClick={() => setOpen((v) => !v)}>
        <span>Legenda</span>
        {open ? <FiChevronDown /> : <FiChevronUp />}
      </button>

      {open && (
        <div className="semafix-legend-panel-body">
          <div className="semafix-legend-section">Semaforo — dati satellitari</div>
          <ConventionLight colored label="Informazioni disponibili" />
          <ConventionLight colored={false} label="Non disponibili" />

          <div className="semafix-legend-section">Semaforo — tipo intersezione</div>
          <div className="semafix-legend-outline-grid">
            {NODE_TYPES.map((type) => {
              const active = !!nodeTypeFilters[type.key];
              return (
                <button
                  type="button"
                  key={type.key}
                  className={`semafix-legend-outline-item semafix-legend-type-btn${active ? '' : ' is-off'}`}
                  onClick={() => onToggleNodeType(type.key, !active)}
                  aria-pressed={active}
                >
                  <span
                    className="semafix-legend-outline-swatch"
                    style={{ borderColor: GEOMETRY_OUTLINE[type.key] }}
                  />
                  <span>{GEOMETRY_LABELS[type.key] || type.label}</span>
                  <b>{nodeTypeCounts[type.key] || 0}</b>
                </button>
              );
            })}
          </div>

          <div className="semafix-legend-section">Semaforo — ottimizzazione piano</div>
          <ConventionLight colored status="plan-optimized" label="Piano ottimizzato" />
          <ConventionLight colored status="plan-pending" label="Da ottimizzare" />
        </div>
      )}
    </div>
  );
}
